import axios from "axios";
import qs from "qs";
import { AxiosCanceler } from "./axiosCancel";

import Topic from "./topic.js";

let topic = new Topic();
axios.defaults.timeout = 50000;
axios.defaults.withCredentials = true;

axios.defaults.baseURL = "/";
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded",
};
// http://h5.tb.daily.baohantong.net/bh-external/#/
// 取消加载的句柄
const axiosCanceler = new AxiosCanceler();
// home下  <router-view v-loading="showLoading"  /> 需要laoding的接口
//http 请求 拦截器
// http://www.tb.daily.baohantong.net/s/QWLuYNXeoN
axios.interceptors.request.use(
  (config) => {
    axiosCanceler.addPending(config);
    topic.loadingOpen(config.url);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
//http 响应 拦截器
axios.interceptors.response.use(
  (response) => {
    response && axiosCanceler.removePending(response.config);
    topic.loadingClose(response.config.url);
    try {
      if (response.data.code == 401) {
        window.location.href = "#/login";
        axiosCanceler.removeAllPending();
        localStorage.setItem("relogin", "1");

        return Promise.reject(response.data);
      }

      if (response.data.code == 1000 || response.data.code == 500) {
        topic.tipsOpen(response.config.url, {
          msg: response.data.msg,
          type: "error",
        });
        return Promise.reject(response.data);
      }
    } catch (e) {
      console.log(e);
    }
    return response.data;
  },
  (error) => {
    console.log(error);
    topic.loadingClose();
    return Promise.reject(error);
  }
);
const hasOwnProperty = Object.prototype.hasOwnProperty;
export default {
  post: function (param) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: param.url,
        data: qs.stringify(param.data),
      })
        .then((res) => {
          if (res.code == 200) {
            if (hasOwnProperty.call(res, "data")) {
              param.success && param.success(res.data);
            } else {
              param.success && param.success(res);
            }
          } else {
            param.fail && param.fail(res);
          }
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          param.fail && param.fail(err);
        });
    });
  },
  get: function (param) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: param.url,
        params: param.data,
      })
        .then((res) => {
          if (res.code == 200) {
            if (hasOwnProperty.call(res, "data")) {
              param.success && param.success(res.data);
            } else {
              param.success && param.success(res);
            }
          } else {
            param.fail && param.fail(res);
          }
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          param.fail && param.fail(err);
        });
    });
  },

  uploadFile: function (param) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: param.url,
        data: param.data,
        withCredentials: false,
        headers: {
          "Content-Type": "multipart/form-data",
        },
        // 上传进度
        onUploadProgress: (progressEvent) => {
          let progress = ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onUploadProgress ? param.onUploadProgress(progress) : "";
        },
      })
        .then((res) => {
          if (res.code == 1000) {
            param.fail && param.fail(res);
          }
          if (res.code == 200) {
            param.success && param.success(res.data);
          }
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
